import { render } from "./AppEntry.vue?vue&type=template&id=6db25262"
import script from "./AppEntry.vue?vue&type=script&lang=ts"
export * from "./AppEntry.vue?vue&type=script&lang=ts"
script.render = render

export default script